/**
 * @generated SignedSource<<a1195a2f420cbc2788fc7383c0488cf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCourseQuizAnswerInput = {
  questionAnswers: ReadonlyArray<CreateCourseQuizQuestionAnswerInput>;
  quiz: string;
};
export type CreateCourseQuizQuestionAnswerInput = {
  option: string;
  question: string;
};
export type courseQuizMutation$variables = {
  includeQuestions: ReadonlyArray<string>;
  input: CreateCourseQuizAnswerInput;
};
export type courseQuizMutation$data = {
  readonly courseQuizAnswer: {
    readonly id: string;
    readonly isCorrect: boolean;
    readonly quiz: {
      readonly courseClass: {
        readonly course: {
          readonly certificate: {
            readonly id: string;
          } | null | undefined;
          readonly certificateEmission: boolean;
          readonly completed: boolean;
          readonly id: string;
          readonly slug: string;
        };
        readonly slug: string;
      };
      readonly id: string;
      readonly questions: ReadonlyArray<{
        readonly answer: {
          readonly id: string;
        } | null | undefined;
        readonly id: string;
      }>;
    };
  };
};
export type courseQuizMutation = {
  response: courseQuizMutation$data;
  variables: courseQuizMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeQuestions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "courseQuizAnswerInput",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCorrect",
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "includes",
      "variableName": "includeQuestions"
    }
  ],
  "concreteType": "QuizQuestion",
  "kind": "LinkedField",
  "name": "questions",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "QuizQuestionOption",
      "kind": "LinkedField",
      "name": "answer",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Course",
  "kind": "LinkedField",
  "name": "course",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "certificateEmission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Certificate",
      "kind": "LinkedField",
      "name": "certificate",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "courseQuizMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QuizAnswer",
        "kind": "LinkedField",
        "name": "courseQuizAnswer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Quiz",
            "kind": "LinkedField",
            "name": "quiz",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseQuiz",
                "kind": "LinkedField",
                "name": "courseClass",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "courseQuizMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QuizAnswer",
        "kind": "LinkedField",
        "name": "courseQuizAnswer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Quiz",
            "kind": "LinkedField",
            "name": "quiz",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseQuiz",
                "kind": "LinkedField",
                "name": "courseClass",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4f69e93d132bdb275aa584f99b654e9f",
    "id": null,
    "metadata": {},
    "name": "courseQuizMutation",
    "operationKind": "mutation",
    "text": "mutation courseQuizMutation(\n  $input: CreateCourseQuizAnswerInput!\n  $includeQuestions: [String!]!\n) {\n  courseQuizAnswer(courseQuizAnswerInput: $input) {\n    id\n    isCorrect\n    quiz {\n      id\n      questions(includes: $includeQuestions) {\n        id\n        answer {\n          id\n        }\n      }\n      courseClass {\n        slug\n        course {\n          id\n          slug\n          certificateEmission\n          completed\n          certificate {\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53bb9dfe1a8754fa1abc097218651860";

export default node;
